export function useEventListeners(context) {
	const listeners = new Map();

	function addListener(target, event, handler) {
		const boundHandler = handler.bind(context);
		listeners.set(handler, { target, event, boundHandler });
		target.addEventListener(event, boundHandler);
	}

	function removeListener(target, event, handler) {
		const entry = listeners.get(handler);
		if (entry) {
			target.removeEventListener(event, entry.boundHandler);
			listeners.delete(handler);
		}
	}

	function removeAllListeners() {
		for (const { target, event, boundHandler } of listeners.values()) {
			target.removeEventListener(event, boundHandler);
		}
		listeners.clear();
	}

	return {
		addListener,
		removeListener,
		removeAllListeners,
	};
}

export function getKeyboardFocusableElements(element = document, selector = '[data-element-mobile]') {
	return [...element.querySelectorAll(selector)].filter((el) => {
		const style = window.getComputedStyle(el);

		// const isVisible = style.display !== 'none' && style.visibility !== 'hidden';
		const isNotDisabled = !el.hasAttribute('disabled');
		const isNotAriaHidden = el.getAttribute('aria-hidden') !== 'true';
		const isNotInert = !el.hasAttribute('inert');

		return isNotDisabled && isNotAriaHidden && isNotInert;
	});
}

export function evalScripts(next) {
	var parser = new DOMParser();
	var htmlDoc = parser.parseFromString(next.html, 'text/html');
	const scripts = htmlDoc.getElementsByTagName('script');

	function evalInWindow(src) {
		const func = function () {
			eval(src);
		};

		// Define event to prevent errors in gform javascript
		const backup = window.event;
		window.event = {};
		func.call(window);
		delete window.event;

		if (backup !== undefined) {
			window.event = backup;
		} else {
			window.event = {
				preventDefault() {},
			};
		}
	}

	[...scripts].forEach((script) => {
		if (script.hasAttribute('data-barba-include')) {
			let src = script.innerHTML;

			try {
				evalInWindow(src);
			} catch (e) {
				console.error(e);
			}
		}
	});
}
